import { useLocation } from 'react-router-dom';
import { FieldErrors } from 'react-hook-form';
import { Dropzone } from '@dropzone-ui/react';
import { useFunctionsButtons } from '../../../../hooks/use-function-button.hook';
import useBgPages from '../../../../hooks/use-bg-pages.hook';
import Input from '../../../../components/forms/input.component';
import TextAreaRCS from '../../../../components/forms/text-area-rcs.component';
import Icon from '../../../../components/forms/icon.component';
import SimpleTitle from '../../../../components/forms/simple-titles.component';
import Tooltip from '../../../../components/forms/tooltip.component';
import RedirectButton from '../components/redirect-button.component';
import CallButton from '../components/call-button.component';
import LocationButton from '../components/location-button.component';
import CalendarButton from '../components/calendar-button.component';
import AnswerButton from '../components/answer-button.component';
import React from 'react';

function richCard({
  type,
  index,
  actionCounts,
  actionElement
}: {
  type: any;
  index: number;
  actionCounts: any;
  actionElement: any;
  activeActions: any;
}) {
  useBgPages();
  const location = useLocation();
  const { payload } = location.state || {};
  const actionComponents: Record<string, React.ComponentType<any>> = {
    redirect: RedirectButton,
    call: CallButton,
    location: LocationButton,
    calendar: CalendarButton,
    answer: AnswerButton
  };

  const {
    t,
    register,
    watch,
    errors,
    setValue,
    handleKeyDown,
    handleRemoveElement,
    handleActionClick,
    files,
    actions,
    handleUpdateFiles
  } = useFunctionsButtons();

  return (
    <React.Fragment key={`richCard-${index}`}>
      <div className="d-flex justify-content-between align-items-center">
        <SimpleTitle
          title={
            <span className="fw-bold fs-4">
              <span className="fw-bolder">Tarjeta enriquecida</span>
            </span>
          }
          subtitle={<span className="">Ingresa los campos de tu tarjeta enriquecida.</span>}
        />
        <div className="d-flex gap-2 mb-10">
          <button
            type="button"
            className="btn btn-light-danger p-1 ms-2 hover-scale"
            onClick={() => handleRemoveElement(index)}
          >
            <Icon icon="ki-abstract-11" size="fs-3" className="ms-1 fw-bolder" />
          </button>
        </div>
      </div>
      <div
        key={`${type}_${index}`}
        className="accordion accordion-icon-toggle mb-5"
        id={`acordion_onlyCard.${index}`}
      >
        <div
          className="accordion-header collapsed py-3 d-flex"
          data-bs-target={`#acordion_onlyCard_item_.${index}`}
          data-bs-toggle="collapse"
          aria-expanded="false"
        >
          <span className="accordion-icon">
            <Icon icon="ki-arrow-right" size="fs-1" />
          </span>
          <h4 className="fs-6 fw-semibold mb-0 ms-4 text-primary fw-bolder mt-1">
            {t('templates.rcs.create.swipe-card-title')}
          </h4>
        </div>
        <div
          className="fs-6 collapse ps-10"
          data-bs-parent={`#acordion_onlyCard.${index}`}
          id={`acordion_onlyCard_item_.${index}`}
        >
          <div className="mb-10 mt-0 border p-10 rounded-12">
            <div className="row mb-10">
              <div className="d-flex flex-column mb-3">
                <span className="fw-bolder fs-3 required">
                  {t('templates.rcs.create.media-title')}
                </span>
                <span className="fs-6">Ingresa una imagen o un video.</span>
              </div>
              <div className="col-6">
                <div key="1" data-kt-buttons="true">
                  <label
                    className={`btn btn-outline btn-outline-dashed btn-active-light-primary d-flex flex-stack text-start p-6 mb-0 ${
                      watch(`elements.${index}.imageCheck`) ? 'active' : ''
                    }`}
                  >
                    <div className="d-flex align-items-center me-2">
                      <div className="form-check form-check-custom form-check-solid form-check-primary me-6">
                        <input
                          className="form-check-input st-b"
                          type="radio"
                          name={`elements.${index}.imageCheck`}
                          checked={watch(`elements.${index}.imageCheck`)}
                          onChange={() => {
                            const isChecked = watch(`elements.${index}.imageCheck`);
                            setValue(`elements.${index}.imageCheck`, !isChecked);
                            if (!isChecked) {
                              setValue(`elements.${index}.videoCheck`, false);
                              setValue(`elements.${index}.URLVideo`, '');
                              setValue(`elements.${index}.URLImagePoster`, '');
                            }
                          }}
                        />
                      </div>
                      <div className="flex-grow-1">
                        <h2 className="d-flex align-items-center fs-3 fw-bold flex-wrap">
                          {t('templates.rcs.create.image-title')}
                        </h2>
                      </div>
                    </div>
                    <div className="ms-5">
                      <Icon icon="ki-picture" size="fs-2x" type="dark" />
                    </div>
                  </label>
                </div>
              </div>
              <div className="col-6">
                <div key="2" data-kt-buttons="true">
                  <label
                    className={`btn btn-outline btn-outline-dashed btn-active-light-primary d-flex flex-stack text-start p-6 mb-0 ${
                      watch(`elements.${index}.videoCheck`) ? 'active' : ''
                    }`}
                  >
                    <div className="d-flex align-items-center me-2">
                      <div className="form-check form-check-custom form-check-solid form-check-primary me-6">
                        <input
                          className="form-check-input st-b"
                          type="radio"
                          name={`elements.${index}.videoCheck`}
                          checked={watch(`elements.${index}.videoCheck`)}
                          onChange={() => {
                            const isChecked = watch(`elements.${index}.videoCheck`);
                            setValue(`elements.${index}.videoCheck`, !isChecked);
                            if (!isChecked) {
                              setValue(`elements.${index}.imageCheck`, false);
                              setValue(`elements.${index}.URLImage`, '');
                            }
                          }}
                        />
                      </div>
                      <div className="flex-grow-1">
                        <h2 className="d-flex align-items-center fs-3 fw-bold flex-wrap">
                          {t('templates.rcs.create.video-title')}
                        </h2>
                      </div>
                    </div>
                    <div className="ms-5">
                      <Icon icon="ki-google-play" size="fs-2x" type="dark" />
                    </div>
                  </label>
                </div>
              </div>
            </div>
            {(watch(`elements.${index}.videoCheck`) || watch(`elements.${index}.imageCheck`)) && (
              <>
                <div className="row mb-7">
                  <div className="col-md-10 mt-4">
                    {files.length === 0 && (
                      <Dropzone
                        onChange={(files) =>
                          handleUpdateFiles(
                            files,
                            index,
                            'richCard',
                            watch(`elements.${index}.videoCheck`) ? 'headerVideo' : 'headerImage',
                            0
                          )
                        }
                        value={files}
                        className="dropzone cursor-default bg-light"
                        accept={
                          watch(`elements.${index}.videoCheck`) ? '.mp4' : '.png, .jpg, .jpeg, .gif'
                        }
                        maxFiles={1}
                      >
                        <div className="dz-message needsclick">
                          <Icon
                            icon={
                              watch(`elements.${index}.videoCheck`)
                                ? 'ki-google-play'
                                : 'ki-picture'
                            }
                            size="fs-3x"
                            type="primary"
                          />
                          <div className="ms-4">
                            <h3 className="fs-7 fw-bold text-gray-900 mb-0">
                              {t('templates.rcs.create.drag-file')}
                            </h3>
                            <div className="d-flex flex-column">
                              <span className="d-block fs-9 fw-semibold mb-1">
                                {watch(`elements.${index}.videoCheck`)
                                  ? '.mp4'
                                  : '.png .jpg .jpeg o .gif'}
                              </span>

                              <span className="fs-8 fw-semibold text-info">
                                {watch(`elements.${index}.videoCheck`)
                                  ? 'video'
                                  : 'Imagen (resolución: 1440 × 720 px)'}
                              </span>
                            </div>
                          </div>
                        </div>
                      </Dropzone>
                    )}
                  </div>
                </div>
              </>
            )}
            {watch(`elements.${index}.imageCheck`) && (
              <div className="fv-row mb-10">
                <Input
                  label={t('templates.rcs.create.url-image-label')}
                  requiredIndicator="required"
                  placeholder="https://www.dominio.com/nombre-imagen.jpg"
                  errors={(errors.elements as FieldErrors[] | undefined)?.[index]?.URLImage}
                  {...register(`elements.${index}.URLImage`, {
                    required: true,
                    pattern: {
                      value: /^(https?:\/\/.*\.(?:png|jpg|jpeg|gif))$/i,
                      message:
                        'La URL no es válida los formatos deben ser .png .jpg .jpeg o .gif, ejemplo: https://www.dominio.com/nombre-imagen.jpg'
                    }
                  })}
                />
              </div>
            )}
            {watch(`elements.${index}.videoCheck`) && (
              <>
                <div className="fv-row mb-7">
                  <Input
                    label={t('templates.rcs.create.url-video-label')}
                    requiredIndicator="required"
                    placeholder="https://www.dominio.com/nombre-video.mp4"
                    errors={(errors.elements as FieldErrors[] | undefined)?.[index]?.URLVideo}
                    {...register(`elements.${index}.URLVideo`, {
                      required: true,
                      pattern: {
                        value: /^(https?:\/\/.*\.(?:mp4))$/i,
                        message:
                          'La URL no es válida el formato debe ser .mp4, ejemplo: https://www.dominio.com/nombre-video.mp4'
                      }
                    })}
                  />
                </div>
                <>
                  <div className="row mb-7">
                    <div className="col-md-10">
                      <Dropzone
                        onChange={(files) =>
                          handleUpdateFiles(files, index, 'richCard', 'posterImage', 0)
                        }
                        className="dropzone cursor-default bg-light"
                        accept=".png, .jpg, .jpeg, .gif"
                        maxFiles={1}
                      >
                        <div className="dz-message needsclick">
                          <Icon icon="ki-picture" size="fs-3x" type="primary" />
                          <div className="ms-4">
                            <h3 className="fs-7 fw-bold text-gray-900 mb-0">
                              {t('templates.rcs.create.drag-file')}
                            </h3>
                            <div className="d-flex flex-column">
                              <span className="d-block fs-9 fw-semibold mb-1">
                                .png .jpg .jpeg o .gif
                              </span>

                              <span className="fs-8 fw-semibold text-info">
                                Poster de video (.png .jpg .jpeg o .gif 1440 X 720px)
                              </span>
                            </div>
                          </div>
                        </div>
                      </Dropzone>
                    </div>
                  </div>
                </>
                <div className="fv-row mb-10">
                  <Input
                    label={t('templates.rcs.create.url-poster-video-label')}
                    optional
                    placeholder=" https://www.dominio.com/nombre-poster.jpg"
                    errors={(errors.elements as FieldErrors[] | undefined)?.[index]?.URLImagePoster}
                    {...register(`elements.${index}.URLImagePoster`, {
                      required: false,
                      pattern: {
                        value: /^(https?:\/\/.*\.(?:png|jpg|jpeg|gif))$/i,
                        message:
                          'La URL no es válida los formatos deben ser .png .jpg .jpeg o .gif, ejemplo: https://www.dominio.com/nombre-poster.jpg'
                      }
                    })}
                  />
                </div>
              </>
            )}
            <div className="fv-row mb-7">
              <div className="d-flex flex-column mb-3">
                <span className="fw-bolder fs-3">
                  {t('templates.rcs.create.title-label')}{' '}
                  <span className="fs-8 ms-1">({t('general.optional')})</span>
                </span>
              </div>
              <Input
                optional
                placeholder={t('templates.rcs.create.title-placeholder')}
                currentLength={watch(`elements.${index}.title`)?.length || 0}
                errors={(errors.elements as FieldErrors[] | undefined)?.[index]?.title}
                onKeyDown={(e: any) => handleKeyDown(e, 200)}
                {...register(`elements.${index}.title`, {
                  required: false,
                  maxLength: { value: 200, message: '200' }
                })}
                maxLength={200}
              />
            </div>
            <div className="fv-row mb-10">
              <TextAreaRCS
                optional
                label={t('templates.rcs.create.message-label')}
                inputName={`elements.${index}.description`}
                payload={payload?.rows?.basic?.text ? { message: payload.rows.basic.text } : ''}
                placeholder={t('templates.rcs.create.message-placeholder')}
                errors={(errors.elements as FieldErrors[] | undefined)?.[index]?.description}
                counter={2000}
                setValue={setValue}
                {...register(`elements.${index}.description`, {
                  required: false,
                  maxLength: {
                    value: 2000,
                    message: '2000'
                  }
                })}
              />
            </div>
            <div className="fv-row mb-1">
              <div className="d-flex flex-stack cursor-pointer mb-3">
                <div className="d-flex align-items-center me-2">
                  <span className="symbol me-6 symbol-label"></span>
                  <div className="d-flex flex-column mg-ch">
                    <span className="fw-bolder fs-3">
                      Botones de tarjeta
                      <span className="fs-6 ms-1">({t('general.optional')})</span>
                    </span>
                    <span className="fs-6">
                      Elige máximo <strong className="text-danger">4</strong> botones para tu
                      tarjeta enriquecida.
                    </span>
                  </div>
                </div>
                <span className="form-check form-check-custom form-check-solid"></span>
              </div>
            </div>
            <div className="mb-8 bg-default p-2 rounded-12 w-100 text-nowrap">
              <div className="badge badge-lg badge-light-primary rounded-12">
                {actions.map(({ key, icon, title, label }) => (
                  <div key={key} className="ms-4">
                    <Tooltip
                      title={title}
                      className="width-fit-content d-inline-block cursor-pointer"
                    >
                      <button
                        type="button"
                        onClick={(e) => {
                          const tooltipEl = e.currentTarget.closest('[data-bs-toggle="tooltip"]');
                          const tooltip = window.bootstrap?.Tooltip?.getInstance?.(tooltipEl);
                          tooltip?.hide?.();
                          handleActionClick(index, null, key, 'richCard');
                        }}
                        className="btn btn-sm rounded-12 align-items-center hover-scale px-0 py-3"
                      >
                        <div className="d-flex align-items-center cursor-pointer">
                          {icon}
                          <div className="fw-bolder ms-1">
                            <span className="d-none d-md-inline-block fs-7 text-primary">
                              {label}{' '}
                              {actionCounts[key] > 0 && (
                                <span className="symbol-badge badge badge-circle bg-info text-white fw-bolder ms-1">
                                  {actionCounts[key]}
                                </span>
                              )}
                            </span>
                          </div>
                        </div>
                      </button>
                    </Tooltip>
                  </div>
                ))}
              </div>
            </div>
            {actionElement?.actions?.map((action: any, actionIndex: number) => {
              const ActionComponent = actionComponents[action.type];
              if (!ActionComponent) return null;

              const commonProps = { actionIndex, index, type: 'richCard' };
              const isLast = actionIndex === actionElement.actions.length - 1;
              const shouldAddSeparator = actionElement.actions.length > 1 && !isLast;

              return (
                <React.Fragment key={actionIndex}>
                  <ActionComponent
                    {...commonProps}
                    {...(action.type === 'calendar' ? { payload } : {})}
                  />
                  {shouldAddSeparator && (
                    <div className="separator separator-dashed text-dark my-5 border-2"></div>
                  )}
                </React.Fragment>
              );
            })}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default richCard;
